import { memo } from 'react'

const GlobeIcon = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    >
      <g
        stroke="#637381"
        strokeLinecap="round"
        strokeLinejoin="round"
        clipPath="url(#clip0_3057_6849)"
      >
        <path d="M8 14.666A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.333"></path>
        <path d="m1.667 8.333 3.666 1.333L4.667 12l.666 2M11.333 13.666 11 12l-1.667-.667V9l2-.667 3 .333M12.667 3.667l-.334 1L10 5v2l1.667-.666H13L14.333 7M1.667 7l1.666-1.333L5 5.333l1.333-2L5.667 2"></path>
      </g>
      <defs>
        <clipPath id="clip0_3057_6849">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default memo(GlobeIcon);
